var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-inline btn btn-primary py-2-and-half font-weight-bold btn-amio-orange fa-chevron-right",attrs:{"href":"","role":"button"},on:{"click":_vm.onClickContactUs}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }